import { render, staticRenderFns } from "./TabsButtonsPricing.vue?vue&type=template&id=281ebdc0&scoped=true"
import script from "./TabsButtonsPricing.vue?vue&type=script&lang=js"
export * from "./TabsButtonsPricing.vue?vue&type=script&lang=js"
import style0 from "./TabsButtonsPricing.vue?vue&type=style&index=0&id=281ebdc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281ebdc0",
  null
  
)

export default component.exports